<template>
  <div>
    <DateSelectProps ref="dateSelect" :selectedDate="selectedDate" :disabled="true" :noShotCuts="true"
                     :disabledDatesBefore="disabledDates"/>
    <textarea v-model="textReason" class="form-control mt-2" placeholder="Комментарий к действию"/>
  </div>
</template>
<script>
import DateSelectProps from "@/views/reports/components/DateSelectProps.vue";

export default {
  props: ['plusDays'],
  components: {DateSelectProps},
  data() {
    return {
      textReason: null,
      selectedDate: (new Date()).setDate((new Date()).getDate() + 5),
      disabledDates: new Date(),
    }
  },
  created() {
    if (this.plusDays) {
      this.selectedDate = (new Date()).setDate((new Date()).getDate() + +this.plusDays);
    }
  },
  methods: {
    getData() {
      return {text: this.textReason, date: this.$refs.dateSelect.date};
    }
  }
}
</script>
